import { render } from "./SheetTypesListComponent.vue?vue&type=template&id=070a1c16&scoped=true"
import script from "./SheetTypesListComponent.vue?vue&type=script&lang=js"
export * from "./SheetTypesListComponent.vue?vue&type=script&lang=js"

import "./SheetTypesListComponent.vue?vue&type=style&index=0&id=070a1c16&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070a1c16"]])

export default __exports__